import { IDichVuSelectRequest } from '../../../models/request/dich-vu/dichVuRequests';
import { ISaleSetRegisterInsertMultipleRequest } from '../../../models/request/dich-vu/saleSetRegisterRequests';
import { SaleSetRegisterHTNopPhiItemResponse } from '../../../models/response/dich-vu/sf_saleset_register_htnopphi';
import { sf_saleset_register_type, SaleSetRegisterTypeItemResponse } from '../../../models/response/dich-vu/sf_saleset_register_type';

export enum eSaleSetRegisterActionTypeIds {
	LOAD_START = "SALESET_REGISTER_LOAD_START",
	LOAD_SUCCESS = "SALESET_REGISTER_LOAD_SUCCESS",
	LOAD_ERROR = "SALESET_REGISTER_LOAD_ERROR",

	LOAD_REGISTER_TYPE_START = "SALESET_REGISTER_LOAD_REGISTER_TYPE_START",
	LOAD_REGISTER_TYPE_SUCCESS = "SALESET_REGISTER_LOAD_REGISTER_TYPE_SUCCESS",
	LOAD_REGISTER_TYPE_ERROR = "SALESET_REGISTER_LOAD_REGISTER_TYPE_ERROR",

	LOAD_REGISTER_TYPE_BY_HOCSINH_START = "SALESET_REGISTER_LOAD_REGISTER_TYPE_BY_HOCSINH_START",
	LOAD_REGISTER_TYPE_BY_HOCSINH_SUCCESS = "SALESET_REGISTER_LOAD_REGISTER_TYPE_BY_HOCSINH_SUCCESS",
	LOAD_REGISTER_TYPE_BY_HOCSINH_ERROR = "SALESET_REGISTER_LOAD_REGISTER_TYPE_BY_HOCSINH_ERROR",

	SHOW_DETAIL = "SALESET_REGISTER_SHOW_DETAIL",
	CLOSE_DETAIL = "SALESET_REGISTER_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "SALESET_REGISTER_CHANGE_SELECTED_IDS",

	SAVE_START = "SALESET_REGISTER_SAVE_START",
	SAVE_SUCCESS = "SALESET_REGISTER_SAVE_SUCCESS",
	SAVE_ERROR = "SALESET_REGISTER_SAVE_ERROR"
}

export interface ISaleSetRegisterLoadStart {
	type: eSaleSetRegisterActionTypeIds.LOAD_START,
	payload: IDichVuSelectRequest
}
export interface ISaleSetRegisterLoadSuccess {
	type: eSaleSetRegisterActionTypeIds.LOAD_SUCCESS,
	payload: SaleSetRegisterHTNopPhiItemResponse[]
}
export interface ISaleSetRegisterLoadErr {
	type: eSaleSetRegisterActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface ISaleSetRegisterTypeLoadStart {
	type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_START
}
export interface ISaleSetRegisterTypeLoadSuccess {
	type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_SUCCESS,
	payload: sf_saleset_register_type[]
}
export interface ISaleSetRegisterTypeLoadErr {
	type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_ERROR,
	payload: string
}
export interface ISaleSetRegisterTypeByHocSinhLoadStart {
	type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_START,
	payload: number
}
export interface ISaleSetRegisterTypeByHocSinhLoadSuccess {
	type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_SUCCESS,
	payload: SaleSetRegisterTypeItemResponse[]
}
export interface ISaleSetRegisterTypeByHocSinhLoadErr {
	type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_ERROR,
	payload: string
}
export interface ISaleSetRegisterShowDetail {
	type: eSaleSetRegisterActionTypeIds.SHOW_DETAIL,
	payload: SaleSetRegisterHTNopPhiItemResponse
}
export interface ISaleSetRegisterCloseDetail {
	type: eSaleSetRegisterActionTypeIds.CLOSE_DETAIL
}
export interface ISaleSetRegisterChangeSelectedIds {
	type: eSaleSetRegisterActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface ISaleSetRegisterSaveStart {
	type: eSaleSetRegisterActionTypeIds.SAVE_START,
	payload: ISaleSetRegisterInsertMultipleRequest
}
export interface ISaleSetRegisterSaveSuccess {
	type: eSaleSetRegisterActionTypeIds.SAVE_SUCCESS
}
export interface ISaleSetRegisterSaveErr {
	type: eSaleSetRegisterActionTypeIds.SAVE_ERROR,
	payload: string
}

export type ISaleSetRegisterActionTypes = ISaleSetRegisterLoadStart | ISaleSetRegisterLoadSuccess | ISaleSetRegisterLoadErr |
	ISaleSetRegisterTypeLoadStart | ISaleSetRegisterTypeLoadSuccess | ISaleSetRegisterTypeLoadErr |
	ISaleSetRegisterTypeByHocSinhLoadStart | ISaleSetRegisterTypeByHocSinhLoadSuccess | ISaleSetRegisterTypeByHocSinhLoadErr |
	ISaleSetRegisterShowDetail | ISaleSetRegisterCloseDetail |
	ISaleSetRegisterChangeSelectedIds |
	ISaleSetRegisterSaveStart | ISaleSetRegisterSaveSuccess | ISaleSetRegisterSaveErr
